import { MOTION_VALUES } from "./motion-constants";

const duration = {
	instant: { value: `${MOTION_VALUES.duration.instant * 1000}ms` },
	rapid: { value: `${MOTION_VALUES.duration.rapid * 1000}ms` },
	fast: { value: `${MOTION_VALUES.duration.fast * 1000}ms` },
	normal: { value: `${MOTION_VALUES.duration.normal * 1000}ms` },
	moderate: { value: `${MOTION_VALUES.duration.moderate * 1000}ms` },
	slow: { value: `${MOTION_VALUES.duration.slow * 1000}ms` },
};

const delay = {
	none: { value: `${MOTION_VALUES.delay.none * 1000}ms` },
	short: { value: `${MOTION_VALUES.delay.short * 1000}ms` },
	medium: { value: `${MOTION_VALUES.delay.medium * 1000}ms` },
	long: { value: `${MOTION_VALUES.delay.long * 1000}ms` },
};

const easing = {
	in: { value: "cubic-bezier(0.4, 0, 1, 1)" },
	out: { value: "cubic-bezier(0, 0, 0.2, 1)" },
	inOut: { value: "cubic-bezier(0.4, 0, 0.2, 1)" },
};

// custom motion definitions
export const motion = {
	default: {
		y: { value: "{spacing.none}" },
	},
	raised: {
		y: { value: "{spacing.ixs}" },
	},
	squeeze_1: {
		scaleX: { value: "100%" },
		scaleY: { value: "100%" },
	},
	squeeze_2: {
		scaleX: { value: "110%" },
		scaleY: { value: "90%" },
	},
	duration,
	delay,
	easing,
};
export const semanticMotion = {
	rest: {
		y: { value: "{motion.default.y}" },
	},
	rise: {
		y: { value: "{motion.raised.y}" },
	},
};
